import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Box, Text } from '@stockx/ui';
import { ChevronLeftIcon } from '@stockx/icons';
import { Link, useUrlBuilder } from '@app/router';
import { NavBarInner } from '@app/shell/SiteHeader/shared/components/Header.styles';
import ListEditDropdownMobile from '@account/pages/Favorites/components/Lists/components/FavoritesList/components/ListEdit/ListEditDropdownMobile';
import { useShowFavoritesPage } from '@account/pages/Favorites/hooks';

const FavoritesMobile = () => {
  const { t } = useTranslation();
  const buildUrl = useUrlBuilder();
  const { milestone } = useShowFavoritesPage();

  return (
    <NavBarInner data-component="MobileNavBarInner">
      <Flex
        width="100%"
        flexDirection="row"
        justifyContent="space-between"
        marginX="4"
        alignItems="center"
      >
        <Flex alignItems="center">
          <ChevronLeftIcon boxSize="5" />
          <Link to={buildUrl('/favorites')}>
            <Text variant="medium" fontSize="sm" marginLeft="1">
              {t('Favorites')}
            </Text>
          </Link>
        </Flex>
        {milestone === 2 && (
          <Box>
            <ListEditDropdownMobile />
          </Box>
        )}
      </Flex>
    </NavBarInner>
  );
};

export default FavoritesMobile;
